// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/slick-carousel/slick/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/slick-carousel/slick/slick-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */
.root{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    overflow: hidden;
}

.slider {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh; /* 화면 전체 높이를 차지하도록 설정 */
    overflow: hidden;
    position: relative;
}

.box {
    width: 100%;
    height: 100%; /* 부모 요소의 높이를 차지하도록 설정 */
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    margin: 0;
    padding: 0;
}

.topslider {
    width: 100%;
    height: 100%;/* 부모 요소의 높이를 차지하도록 설정 */
    overflow: hidden;
    position: relative;
}

.topslider div {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
}

.topslider img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* 비율을 유지하지 않고, 슬라이더의 크기에 맞게 조정 */
    position: absolute;
    top: 0;
    left: 0;
    animation: zoomIn 10s ease-in-out;
    animation-fill-mode: forwards;
}

@keyframes zoomIn {
    0% {
        transform: scale(1.1); /* 초기 상태에서 원래 크기 */
    }
    100% {
        transform: scale(1); /* 중간 상태에서 10% 확대 */
    }
}

.slick-dots {
    position: absolute;
    bottom: 20px; /* 이미지 안에서 dots의 위치를 조정 */
    left: 50%;
    transform: translateX(-50%);
    display: flex !important;
    justify-content: center;
    align-items: center;
}

.slick-dots li {
    margin: 0 4px; /* dot 사이의 간격 조정 */
}

.slick-dots li button:before {
    color: #ffffff; /* dots의 색상을 변경 */
}

.overlay {
    position: absolute;
    bottom: 70%;
    left: 50%;

    transform: translateX(-50%);
    color: white;
    font-size: 1.5rem;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    text-align: center;
    width: 100%;
    animation-name:fade;
    animation-duration: 3s;
}

.title2{
    position: absolute;
    bottom: 50%;
    left: 50%;
    transform: translateX(-50%);
    color: whitesmoke;
    font-size: 5rem;
    font-weight: bold;
    text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5);
    text-align: center;
    width: 100%;
    animation-name:fade;
    animation-duration: 5s;
}
/*.title2:hover {*/
/*    transform: translateY(-5px);*/
/*    color: rgb(255, 255, 255);*/
/*    filter: drop-shadow(0 0 2px rgba(0, 196, 255, 0.7))*/
/*    drop-shadow(0 0 5px rgba(0, 196, 255, 0.7))*/
/*    drop-shadow(0 0 15px rgba(0, 196, 255, 0.7));*/
/*}*/

@keyframes move {
    from { transform: translateY(-40%); }
    to   { transform: translateY(0);}
}

@keyframes fade {
    from { opacity: 0; }
    to   { opacity: 1; }
}

.card-wrapper{
    flex-wrap: wrap;
    width: 100%;
    background-color: #fffefe;
    padding: 50px;
}

.division-line {
    position: relative;
    width: 0; /* 초기 상태에서 너비를 0으로 설정 */
    height: 3px;
    background-color: #a7c898;
    margin: 30px 0;
    transition: width 4s; /* 애니메이션 적용 */
}

.division-line.visible {
    opacity: 1;
    width: 500px;
}

.more-link {
    opacity: 0;
    transform: translateY(20px); /* 아래에서 위로 나타나는 효과 */
    transition: opacity 3s ease, transform 3s ease; /* 애니메이션 속성 */
    font-size: 1rem;
    color: rgba(135, 135, 135, 0.77);
    text-decoration: none;
    margin-top: 10px;.more-link {

    display: inline-block;
}
    .more-link.visible {
        opacity: 1;
        transform: translateY(0); /* 원래 위치로 */
    }

    .more-link:hover {
        color: #6aaa7d;
    }
    display: inline-block;
}

.more-link.visible {
    opacity: 1;
    transform: translateY(0); /* 원래 위치로 */
}

.more-link:hover {
    color: #a7c898;
}

@keyframes expandLine {
    from { width: 0; }
    to { width: 500px; }
}

.notices-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 80%;
    margin: 40px auto;
    margin-top: 40px;
    /*margin-bottom: 150px;*/
}

.card-title{
    width: 100%;
    text-align: center;
    margin-top: 90px;
    margin-bottom: 50px;
    color: #5c5c5c;
    display: flex; /* flexbox 활성화 */
    flex-direction: column; /* 세로 방향으로 정렬 */
    align-items: center; /* 가로 방향 가운데 정렬 */
}

.card-title p,
.card-title span {
    opacity: 0; /* 초기 상태: 보이지 않음 */
    transform: translateY(20px); /* 초기 상태: 아래로 이동 */
    transition: opacity 3s ease, transform 3s ease; /* 애니메이션 설정 */
}

.card-title.visible p,
.card-title.visible span {
    opacity: 1; /* 애니메이션 완료 후 보이도록 설정 */
    transform: translateY(0); /* 애니메이션 완료 후 원래 위치로 */
}

.card-title p {
    font-size: 1.8rem;
    font-weight: bold;
    margin-bottom: 30px;
    /*animation-name:fade,move;*/
    /*animation-duration: 3s;*/
        opacity: 0; /* 초기 상태: 보이지 않음 */
        transform: translateY(20px); /* 초기 상태: 아래로 이동 */
        transition: opacity 3s ease, transform 3s ease;
}

.card-title span {
    font-size: 1rem;
    color: #636363;
    /*animation-name:fade,move;*/
    /*animation-duration: 5s;*/
    opacity: 0;
        transform: translateY(20px); /* 초기 상태: 아래로 이동 */
        transition: opacity 5s ease, transform 5s ease;
}

.notice-card {
    background: rgba(251, 251, 251, 0.82);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    /*border-radius: 8px;*/
    /*padding: 20px;*/
    width: 20%; /* 4개가 가로로 배치되도록 설정 */
    height: 370px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    /*transition: transform 0.3s ease;*/
    /*animation-name:fade;*/
    /*animation-duration: 5s;*/
    transition: opacity 0.8s ease, transform 0.8s ease;
    /*opacity: 0; !* 초기 상태: 보이지 않음 *!*/
    transform: translateY(20px); /* 초기 상태: 아래로 이동 */
    padding-bottom: 30px;
    cursor: pointer;
}

.notice-card.visible {
    opacity: 1;
    transform: translateY(0);
}

.notice-card:hover {
    transform: translateY(-5px);
    background-color: #dadada;
}

.notice-image {
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 8px 8px 0 0;
    margin-bottom: 15px;
    overflow: hidden;
}

.notice-card h3 {
    margin-bottom: 10px;
    padding: 4px;
    font-size: 1.2rem;
    color: #353535;
}

.notice-card p {
    font-size: 1rem;
    color: #61686c;
    padding: 3px;
}

.notice-card span {
    font-size: 0.9rem;
    color: #868e96;
    margin-bottom: 10px;
    display: block;
}

.visible {
    opacity: 1;
    transform: translateY(-10px);
}

.visible .division-line {
    width: 500px; /* 구분선 애니메이션 시작 */
}

@media (max-width: 768px) {
    .slider {
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
    }

    .overlay {
        display: flex;
        justify-content: center;
        align-items: center;
        order: 1; /* 위쪽으로 이동 */
        margin-bottom: 10px;
    }

    .title2 {
        display: flex;
        justify-content: center;
        align-items: center;
        order: 2; /* 아래쪽으로 이동 */
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Main/styles.css"],"names":[],"mappings":"AAAA,eAAe;AAGf;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa,EAAE,uBAAuB;IACtC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY,EAAE,wBAAwB;IACtC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY,CAAC,wBAAwB;IACrC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAE,iCAAiC;IACpD,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA;IACI;QACI,qBAAqB,EAAE,kBAAkB;IAC7C;IACA;QACI,mBAAmB,EAAE,mBAAmB;IAC5C;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY,EAAE,yBAAyB;IACvC,SAAS;IACT,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa,EAAE,kBAAkB;AACrC;;AAEA;IACI,cAAc,EAAE,iBAAiB;AACrC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;;IAET,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;IACjB,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;AACA,kBAAkB;AAClB,mCAAmC;AACnC,iCAAiC;AACjC,0DAA0D;AAC1D,kDAAkD;AAClD,oDAAoD;AACpD,IAAI;;AAEJ;IACI,OAAO,2BAA2B,EAAE;IACpC,OAAO,wBAAwB,CAAC;AACpC;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ,EAAE,uBAAuB;IACjC,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,oBAAoB,EAAE,aAAa;AACvC;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,2BAA2B,EAAE,oBAAoB;IACjD,8CAA8C,EAAE,aAAa;IAC7D,eAAe;IACf,gCAAgC;IAChC,qBAAqB;IACrB,gBAAgB,CAAC;;IAEjB,qBAAqB;AACzB;IACI;QACI,UAAU;QACV,wBAAwB,EAAE,WAAW;IACzC;;IAEA;QACI,cAAc;IAClB;IACA,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,wBAAwB,EAAE,WAAW;AACzC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,OAAO,QAAQ,EAAE;IACjB,KAAK,YAAY,EAAE;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,aAAa,EAAE,gBAAgB;IAC/B,sBAAsB,EAAE,eAAe;IACvC,mBAAmB,EAAE,iBAAiB;AAC1C;;AAEA;;IAEI,UAAU,EAAE,kBAAkB;IAC9B,2BAA2B,EAAE,kBAAkB;IAC/C,8CAA8C,EAAE,aAAa;AACjE;;AAEA;;IAEI,UAAU,EAAE,uBAAuB;IACnC,wBAAwB,EAAE,sBAAsB;AACpD;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,4BAA4B;IAC5B,0BAA0B;QACtB,UAAU,EAAE,kBAAkB;QAC9B,2BAA2B,EAAE,kBAAkB;QAC/C,8CAA8C;AACtD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,4BAA4B;IAC5B,0BAA0B;IAC1B,UAAU;QACN,2BAA2B,EAAE,kBAAkB;QAC/C,8CAA8C;AACtD;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,kCAAkC;IAClC,0CAA0C;IAC1C,sBAAsB;IACtB,iBAAiB;IACjB,UAAU,EAAE,qBAAqB;IACjC,aAAa;IACb,wCAAwC;IACxC,mCAAmC;IACnC,uBAAuB;IACvB,0BAA0B;IAC1B,kDAAkD;IAClD,kCAAkC;IAClC,2BAA2B,EAAE,kBAAkB;IAC/C,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,YAAY,EAAE,iBAAiB;AACnC;;AAEA;IACI;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,QAAQ,EAAE,YAAY;QACtB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,QAAQ,EAAE,aAAa;IAC3B;AACJ","sourcesContent":["/* styles.css */\n@import \"~slick-carousel/slick/slick.css\";\n@import \"~slick-carousel/slick/slick-theme.css\";\n.root{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    overflow: hidden;\n}\n\n.slider {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100vh; /* 화면 전체 높이를 차지하도록 설정 */\n    overflow: hidden;\n    position: relative;\n}\n\n.box {\n    width: 100%;\n    height: 100%; /* 부모 요소의 높이를 차지하도록 설정 */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    position: relative;\n    margin: 0;\n    padding: 0;\n}\n\n.topslider {\n    width: 100%;\n    height: 100%;/* 부모 요소의 높이를 차지하도록 설정 */\n    overflow: hidden;\n    position: relative;\n}\n\n.topslider div {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n}\n\n.topslider img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover; /* 비율을 유지하지 않고, 슬라이더의 크기에 맞게 조정 */\n    position: absolute;\n    top: 0;\n    left: 0;\n    animation: zoomIn 10s ease-in-out;\n    animation-fill-mode: forwards;\n}\n\n@keyframes zoomIn {\n    0% {\n        transform: scale(1.1); /* 초기 상태에서 원래 크기 */\n    }\n    100% {\n        transform: scale(1); /* 중간 상태에서 10% 확대 */\n    }\n}\n\n.slick-dots {\n    position: absolute;\n    bottom: 20px; /* 이미지 안에서 dots의 위치를 조정 */\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex !important;\n    justify-content: center;\n    align-items: center;\n}\n\n.slick-dots li {\n    margin: 0 4px; /* dot 사이의 간격 조정 */\n}\n\n.slick-dots li button:before {\n    color: #ffffff; /* dots의 색상을 변경 */\n}\n\n.overlay {\n    position: absolute;\n    bottom: 70%;\n    left: 50%;\n\n    transform: translateX(-50%);\n    color: white;\n    font-size: 1.5rem;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n    text-align: center;\n    width: 100%;\n    animation-name:fade;\n    animation-duration: 3s;\n}\n\n.title2{\n    position: absolute;\n    bottom: 50%;\n    left: 50%;\n    transform: translateX(-50%);\n    color: whitesmoke;\n    font-size: 5rem;\n    font-weight: bold;\n    text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5);\n    text-align: center;\n    width: 100%;\n    animation-name:fade;\n    animation-duration: 5s;\n}\n/*.title2:hover {*/\n/*    transform: translateY(-5px);*/\n/*    color: rgb(255, 255, 255);*/\n/*    filter: drop-shadow(0 0 2px rgba(0, 196, 255, 0.7))*/\n/*    drop-shadow(0 0 5px rgba(0, 196, 255, 0.7))*/\n/*    drop-shadow(0 0 15px rgba(0, 196, 255, 0.7));*/\n/*}*/\n\n@keyframes move {\n    from { transform: translateY(-40%); }\n    to   { transform: translateY(0);}\n}\n\n@keyframes fade {\n    from { opacity: 0; }\n    to   { opacity: 1; }\n}\n\n.card-wrapper{\n    flex-wrap: wrap;\n    width: 100%;\n    background-color: #fffefe;\n    padding: 50px;\n}\n\n.division-line {\n    position: relative;\n    width: 0; /* 초기 상태에서 너비를 0으로 설정 */\n    height: 3px;\n    background-color: #a7c898;\n    margin: 30px 0;\n    transition: width 4s; /* 애니메이션 적용 */\n}\n\n.division-line.visible {\n    opacity: 1;\n    width: 500px;\n}\n\n.more-link {\n    opacity: 0;\n    transform: translateY(20px); /* 아래에서 위로 나타나는 효과 */\n    transition: opacity 3s ease, transform 3s ease; /* 애니메이션 속성 */\n    font-size: 1rem;\n    color: rgba(135, 135, 135, 0.77);\n    text-decoration: none;\n    margin-top: 10px;.more-link {\n\n    display: inline-block;\n}\n    .more-link.visible {\n        opacity: 1;\n        transform: translateY(0); /* 원래 위치로 */\n    }\n\n    .more-link:hover {\n        color: #6aaa7d;\n    }\n    display: inline-block;\n}\n\n.more-link.visible {\n    opacity: 1;\n    transform: translateY(0); /* 원래 위치로 */\n}\n\n.more-link:hover {\n    color: #a7c898;\n}\n\n@keyframes expandLine {\n    from { width: 0; }\n    to { width: 500px; }\n}\n\n.notices-container {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    width: 80%;\n    margin: 40px auto;\n    margin-top: 40px;\n    /*margin-bottom: 150px;*/\n}\n\n.card-title{\n    width: 100%;\n    text-align: center;\n    margin-top: 90px;\n    margin-bottom: 50px;\n    color: #5c5c5c;\n    display: flex; /* flexbox 활성화 */\n    flex-direction: column; /* 세로 방향으로 정렬 */\n    align-items: center; /* 가로 방향 가운데 정렬 */\n}\n\n.card-title p,\n.card-title span {\n    opacity: 0; /* 초기 상태: 보이지 않음 */\n    transform: translateY(20px); /* 초기 상태: 아래로 이동 */\n    transition: opacity 3s ease, transform 3s ease; /* 애니메이션 설정 */\n}\n\n.card-title.visible p,\n.card-title.visible span {\n    opacity: 1; /* 애니메이션 완료 후 보이도록 설정 */\n    transform: translateY(0); /* 애니메이션 완료 후 원래 위치로 */\n}\n\n.card-title p {\n    font-size: 1.8rem;\n    font-weight: bold;\n    margin-bottom: 30px;\n    /*animation-name:fade,move;*/\n    /*animation-duration: 3s;*/\n        opacity: 0; /* 초기 상태: 보이지 않음 */\n        transform: translateY(20px); /* 초기 상태: 아래로 이동 */\n        transition: opacity 3s ease, transform 3s ease;\n}\n\n.card-title span {\n    font-size: 1rem;\n    color: #636363;\n    /*animation-name:fade,move;*/\n    /*animation-duration: 5s;*/\n    opacity: 0;\n        transform: translateY(20px); /* 초기 상태: 아래로 이동 */\n        transition: opacity 5s ease, transform 5s ease;\n}\n\n.notice-card {\n    background: rgba(251, 251, 251, 0.82);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    /*border-radius: 8px;*/\n    /*padding: 20px;*/\n    width: 20%; /* 4개가 가로로 배치되도록 설정 */\n    height: 370px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    /*transition: transform 0.3s ease;*/\n    /*animation-name:fade;*/\n    /*animation-duration: 5s;*/\n    transition: opacity 0.8s ease, transform 0.8s ease;\n    /*opacity: 0; !* 초기 상태: 보이지 않음 *!*/\n    transform: translateY(20px); /* 초기 상태: 아래로 이동 */\n    padding-bottom: 30px;\n    cursor: pointer;\n}\n\n.notice-card.visible {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.notice-card:hover {\n    transform: translateY(-5px);\n    background-color: #dadada;\n}\n\n.notice-image {\n    width: 100%;\n    height: 150px;\n    object-fit: cover;\n    border-radius: 8px 8px 0 0;\n    margin-bottom: 15px;\n    overflow: hidden;\n}\n\n.notice-card h3 {\n    margin-bottom: 10px;\n    padding: 4px;\n    font-size: 1.2rem;\n    color: #353535;\n}\n\n.notice-card p {\n    font-size: 1rem;\n    color: #61686c;\n    padding: 3px;\n}\n\n.notice-card span {\n    font-size: 0.9rem;\n    color: #868e96;\n    margin-bottom: 10px;\n    display: block;\n}\n\n.visible {\n    opacity: 1;\n    transform: translateY(-10px);\n}\n\n.visible .division-line {\n    width: 500px; /* 구분선 애니메이션 시작 */\n}\n\n@media (max-width: 768px) {\n    .slider {\n        display: flex;\n        flex-direction: column-reverse;\n        align-items: center;\n    }\n\n    .overlay {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        order: 1; /* 위쪽으로 이동 */\n        margin-bottom: 10px;\n    }\n\n    .title2 {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        order: 2; /* 아래쪽으로 이동 */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
